export const LABEL_TRANSLATION_MAP = {
  cash_revenue: 'key.cash_revenue',
  card_revenue: 'key.card_revenue',
  online_revenue: 'key.online_revenue',
} as const;
